
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.125 50.8h-6.8v-.9-1-16.2c12.2-3.8 9.4-16.2 6.4-25.8-.1-.4-.2-.9-.6-.9h-12.9c-.4 0-.5.5-.6.8-3.1 9.7-5.8 21.8 6.4 25.8v16.2c-.1.3-.1.7 0 1.1v.9h-6.8c-1 0-1 3.2 0 3.2h14.9c1-.1 1-3.2 0-3.2zm-13.9-40.7c.2-.6.3-.9.4-1.1.6 0 1.5.1 2 .1h7.8c.7 0 1.8-.2 2.4 0 .1.3.2.7.3 1 .5 2.2 1.5 4.6 2 7.1-2.2.9-4.9.5-7.1.2-3.5-.4-6.4-.4-9.7.6.1-1.4.4-2.7.7-3.9.4-1.3.9-2.6 1.2-4zm-.8 14.7c-.8-1.3-1.1-2.9-1.1-4.5 4.2-1.3 7.5-.6 11.9-.3 1.7.1 3.6.1 5.2-.6.1 1.9-.2 3.7-1.4 5.3-1.5 2-4.8 4.2-7.3 4.9-2.3-.6-6.1-2.8-7.3-4.8z"}})])
          )
        }
      }
    